import { Check } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { ESG_PILLARS } from './consts'

export const ESGSection = () => {
  const { t } = useLocalization()

  return (
    <section className="w-full py-20 md:py-24 bg-gradient-to-b from-gray-50 via-gray-100 to-white">
      <Column className="w-full max-w-6xl mx-auto px-6 md:px-8 gap-10 md:gap-12">
        <Column className="gap-4 items-center text-center">
          <h2 className="text-3xl md:text-4xl font-normal text-slate-800 max-w-2xl">
            {t('Merch that does good', 'Merch som gör gott')}
          </h2>
          <p className="text-slate-500 text-base md:text-lg max-w-xl">
            {t(
              "We believe great products and responsible business go hand in hand. Here's how we hold ourselves accountable. ESG approved.",
              'Vi tror att fantastiska produkter och ansvarsfullt företagande går hand i hand. Så här håller vi oss ansvariga. ESG-godkänt.'
            )}
          </p>
        </Column>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ESG_PILLARS.map((pillar) => (
            <Card
              key={pillar.title}
              wrapperClassName="h-full flex flex-col"
              className="h-full min-w-0 p-6 md:p-8 gap-6"
            >
              <Row className="items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-emerald-100/60 flex items-center justify-center shrink-0">
                  <pillar.icon
                    className="w-6 h-6 text-emerald-600 block"
                    strokeWidth={1.5}
                  />
                </div>
                <Column className="gap-0 min-w-0">
                  <span className="text-xs font-medium text-emerald-600 uppercase tracking-wider">
                    {t(pillar.title)}
                  </span>
                  <h3 className="text-lg text-slate-800 leading-tight">
                    {t(pillar.headline)}
                  </h3>
                </Column>
              </Row>

              <Column className="gap-3">
                {pillar.points.map((point, index) => (
                  <Row key={index} className="items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-emerald-100/80 flex items-center justify-center shrink-0 mt-0.5">
                      <Check
                        className="w-3 h-3 text-emerald-600 block"
                        strokeWidth={2.5}
                      />
                    </div>
                    <p className="text-slate-500 text-sm leading-relaxed min-w-0">
                      {t(point)}
                    </p>
                  </Row>
                ))}
              </Column>
            </Card>
          ))}
        </div>
      </Column>
    </section>
  )
}
